export interface TokenError {
  detail: string;
}

export interface ApiError {
  body: {
    detail?: string;
    [key: string]: unknown;
  };
}

export function isTokenError(error: unknown): error is TokenError {
  return (
    typeof error === 'object' &&
    error !== null &&
    'detail' in error &&
    typeof (error as TokenError).detail === 'string'
  );
}

export function extractTokenErrorMessage(error: unknown): string {
  if (error && typeof error === 'object' && 'body' in error) {
    const body: unknown = error.body;
    if (body && typeof body === 'object' && 'detail' in body) {
      const detail = body.detail;
      return typeof detail === 'string' && detail ? detail : 'Unknown API error';
    }
  }

  if (isTokenError(error)) {
    return error.detail;
  }

  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error === 'string') {
    return error;
  }

  return 'An unknown error occurred';
}
